import { TableCacheNameEnum } from '../../../../hooks/useTableChange/useTableChange';
import { PatientListTypeEnum } from '../../../../uc-api-sdk';
import { PatientsTableContainer } from '../../../patients/container/PatientsTableContainer/PatientsTableContainer';
import { ProviderViewUnenrolledPatientsTableComponent } from '../../component/ProviderViewUnenrolledPatientsTableComponent/ProviderViewUnenrolledPatientsTableComponent';

export interface ProviderViewUnenrolledPatientsTableContainerProps {
  doctorId?: string;
}

export const ProviderViewUnenrolledPatientsTableContainer = ({
  doctorId
}: ProviderViewUnenrolledPatientsTableContainerProps) => (
  <PatientsTableContainer
    type={PatientListTypeEnum.UNENROLLED}
    name={TableCacheNameEnum.UnenrolledPatients}
    doctorId={doctorId}
  >
    {({
      totalSize,
      pagination,
      dataSource,
      onChange,
      filters,
      sorters,
      isLoading,
      exportData,
    }) => (
      <ProviderViewUnenrolledPatientsTableComponent
        totalSize={totalSize}
        pagination={pagination}
        dataSource={dataSource}
        onChange={onChange}
        filters={filters}
        sorters={sorters}
        loading={isLoading}
        exportData={exportData}
      />
    )}
  </PatientsTableContainer>
);
